import _styled from "@emotion/styled/base";
import _size from "lodash/size";
import { ArrowLeftIcon, ArrowRightIcon } from '@datacamp/waffles-icons';
import { colors } from '@datacamp/waffles-tokens';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import orderGroupedItems from '../../lib/orderGroupedItems';
import TopAreaDroppable from './TopAreaDroppable';
import { jsx as ___EmotionJSX } from "@emotion/react";
const PADDING = 24;
const Tasks = _styled("div", {
  target: "ejieod50",
  label: "Tasks"
})(_ref => {
  let {
    width
  } = _ref;
  return {
    alignSelf: 'center',
    background: colors.purple,
    borderRadius: '8px 8px 8px 8px',
    marginTop: PADDING,
    padding: "0 ".concat(PADDING, "px"),
    width
  };
}, "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const TasksArea = _ref2 => {
  let {
    droppableId,
    groupedItems,
    items,
    languageOfTarget,
    maxOffset,
    orderGroupedItems: orderGroupedItemsProp,
    setItemOffset,
    targets,
    width
  } = _ref2;
  const {
    t
  } = useTranslation();
  const nbOfItems = _size(items);
  const incrementIndex = React.useCallback(() => {
    orderGroupedItemsProp(orderGroupedItems(groupedItems, targets, {
      destination: {
        droppableId,
        index: nbOfItems - 1
      },
      source: {
        droppableId,
        index: 0
      }
    }));
  }, [droppableId, groupedItems, nbOfItems, orderGroupedItemsProp, targets]);
  const decrementIndex = React.useCallback(() => {
    orderGroupedItemsProp(orderGroupedItems(groupedItems, targets, {
      destination: {
        droppableId,
        index: 0
      },
      source: {
        droppableId,
        index: nbOfItems - 1
      }
    }));
  }, [droppableId, groupedItems, nbOfItems, orderGroupedItemsProp, targets]);
  const buttonStyleRemoved = {
    background: 'none',
    border: 'none',
    padding: 0
  };
  return ___EmotionJSX(Tasks, {
    width: width
  }, ___EmotionJSX("h5", {
    className: "dc-u-ta-center dc-u-mt-24 dc-u-mb-24 dc-u-color-white"
  }, t('TasksArea.heading')), ___EmotionJSX("div", {
    className: "dc-edge-to-edge dc-u-fx-aic dc-u-mb-12",
    style: {
      margin: '-12px',
      width: "calc(100% + ".concat(PADDING, ")")
    }
  }, ___EmotionJSX(TopAreaDroppable, {
    droppableId: droppableId,
    items: items,
    languageOfTarget: languageOfTarget,
    maxOffset: maxOffset,
    padding: PADDING,
    setItemOffset: setItemOffset
  })), nbOfItems > 1 && ___EmotionJSX("div", {
    className: "dc-edge-to-edge dc-u-fx-aic dc-u-mb-12"
  }, ___EmotionJSX("button", {
    className: "dc-edge-to-edge__item dc-u-pl-0",
    "data-cy": "classify-exercise-previous-card-button",
    onClick: decrementIndex,
    style: buttonStyleRemoved,
    type: "button"
  }, ___EmotionJSX(ArrowLeftIcon, {
    color: colors.white,
    size: "small"
  })), ___EmotionJSX("div", {
    className: "dc-u-color-white"
  }, t('TasksArea.cardLeft', {
    count: nbOfItems
  })), ___EmotionJSX("button", {
    className: "dc-edge-to-edge__item dc-u-pr-0",
    "data-cy": "classify-exercise-next-card-button",
    onClick: incrementIndex,
    style: buttonStyleRemoved,
    type: "button"
  }, ___EmotionJSX(ArrowRightIcon, {
    color: colors.white,
    size: "small"
  }))));
};
export default TasksArea;